import { render, staticRenderFns } from "./StatsKycModal.vue?vue&type=template&id=1b498bc2&"
import script from "./StatsKycModal.vue?vue&type=script&lang=js&"
export * from "./StatsKycModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports